export default __webpack_public_path__ + "media/images/icons/instagram-90a80cd5b9a105845e0d07f0cdaf509b.svg";